var getQuery = function(query, url) {
    if (!url) {
        url = window.location.href;
    }
    
    query = query.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
    var expr = "[\\?&]" + query + "=([^&#]*)";
    var regex = new RegExp(expr);
    var results = regex.exec(url);
    
    if (results !== null) {
        return results[1];
    } else {
        return undefined;
    }
    
};

var escapeHTML = function(htmlString) {
	return htmlString
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;');
};

Array.remove = function(array) {
    var itemToRemove;
    var args = Array.prototype.slice.call(arguments);
    
    if (!!args && args.length > 1) {
        var argumentsArray = args.splice(1);
        var argumentsArrayLength = argumentsArray.length;
        var index = -1;
        
        while (!!argumentsArrayLength && !!array.length) {
            itemToRemove = argumentsArray[--argumentsArrayLength];
            
            while ((index = array.indexOf(itemToRemove)) !== -1) {
                array.splice(index, 1);
            }
        }
    }
    
    return array;
}

var trimValue = function(value) {
    var trimmedString = null;
    
    if (value) {
        trimmedString = value.toString().trim();
    }
    
    return trimmedString;
};

var formatMessage = function(msg, args)
{
	for (var i = 0; i < args.length; i++) {
		var str = "{" + i + "}";
		msg = msg.replace(str, args[i]);
	}
	
	return msg;
};

//Format an integer based on locale
var formatInteger = function(n) {
    return jQuery.formatNumber(n, {format:"#,##0", locale:country});
};

// Format a real based on locale
var formatReal = function(n, digits) {
    // Create a format based on number of digits
    if (!digits)
        digits = 2;
    
    var format = '#,##0.';
    for (var i = 0; i < digits; i++) {
        format += '0';
    }
    return jQuery.formatNumber(n, {format: format, locale: country});
};

// General number formatter - Will format either an integer
// or real value as appropriate
var formatNumber = function(n) {
    var result = null;
    if (n !== undefined) {
	    if (typeof(n) === 'string') {
	    	if (n.length > 0) {
		        if (n.indexOf('.') === -1) {
		            result = formatInteger(parseInt(n));
		        } else {
		            var digits = n.length - n.indexOf('.') - 1;
		            result = formatReal(parseFloat(n), digits);
		        }
	    	}
	    } else {
	        if (Math.round(n) === n) {
	            result = formatInteger(n);
	        } else {
	            result = formatReal(n, 2);
	        }
	    }
    }    
    return result;
};

//Function to add commas to a numeric string
//DEPRECATED! Use appropriate formatting routines above
var addCommas = function(numberString) {
    return formatNumber(numberString);
};

var getBooleanValue = function(value) {
    var booleanValue = false;
    
    if (!!value && value.toString().toLowerCase() === 'true') {
        booleanValue = true;
    }
    
    return booleanValue;
};

//The following two blocks are polyfills that allow us to use Element.closest in IE11 - they are taken from MDN
if (!Element.prototype.matches) {
	Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
	Element.prototype.closest = function(s) {
	var el = this;

	do {
		if (el.matches(s)) return el;
		el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
	};
}

(function($){
	
	function isDebugMode(){
		var queryString = location.search
		
    	var matches = /\?.*debug=(true)&?/i.exec(queryString);
		if (matches){
			return matches[1] == 'true';
		}
	};
	
	if (typeof $ !== 'undefined' && $ != null)
	{
		$.extend({
			debugLog: function(text){
				if (isDebugMode()){
					console.log(text);
				}
			},
		
			htmlEncode: function(value) {
				return $('<div/>').text(value).html();
			}
		});
		
		$.extend({
		    animationDuration: 250,
		    animateOpenDialog : function(dialogID, sourceItem, hideSource, duration, callback) {
		        var effectDuration = !!duration ? duration : $.animationDuration;
		        
		        $(dialogID).dialog('widget').css('visibility', 'hidden');
		        $('.ui-widget-overlay').fadeOut(0);
		        
		        $(sourceItem).effect('transfer', {
		            to: $(dialogID).dialog('widget'),
		            className: 'ui-effects-transfer'
		        }, effectDuration, function () {
		            $(dialogID).dialog('widget').css('visibility', 'visible');
		        });

		        if ((typeof hideSource === 'undefined') || !!hideSource) {
		            $(sourceItem).addClass('source-hidden');
		        }
		        
		        $('.ui-widget-overlay').fadeIn(effectDuration, callback);
		    },
		    animateCloseDialog : function(dialogID, targetItem, showTarget, duration) {
		        var effectDuration = !!duration ? duration : $.animationDuration;
		        
		        $(dialogID).dialog('widget').css('visibility', 'hidden');
		        $('.ui-widget-overlay').fadeOut(effectDuration);
		        
		        $(dialogID).dialog('widget').effect('transfer', {
		            to: $(targetItem),
		            className: 'ui-effects-transfer'
		        }, effectDuration, function() {
		            if ((typeof showTarget === 'undefined') || !!showTarget) {
	                    $(targetItem).removeClass('source-hidden');
		            }
		            
		            $(dialogID).dialog('close');
		        });
		    }
		});	
	}
})(jQuery);